import { Ability, AbilityBuilder } from "@casl/ability";
import PermissionsConfig from "./permissionsConfig";
import CommonUtils from "services/common/utils";

/* eslint-disable class-methods-use-this */
class Abilities {
  constructor() {
    this.initialized = false;
    this.PERMISSIONS_CONFIG = PermissionsConfig;
    this.ability = {
      can: () => false,
    };
    Ability.addAlias("crud", ["read", "write"]);
    Ability.addAlias("write", ["read"]);
  }

  defineAbilitiesFromRights = (rights = []) => {
    this.ability = AbilityBuilder.define((can) => {
      const isSuperAdmin = this.isUserSuperAdmin(rights);

      if (isSuperAdmin) {
        can("crud", "all");
        this.initialized = true;
      } else {
        this.initAllPermissionsFromConfigFile(rights, can).then(() => {
          this.initialized = true;
          return Promise.resolve();
        });
      }
    });

    return Promise.resolve(this.ability);
  };

  initAllPermissionsFromConfigFile(userPermissions = [], can) {
    CommonUtils.iterateKeysAnDo(this.PERMISSIONS_CONFIG, (entity) =>
      CommonUtils.iterateKeysAnDo(this.PERMISSIONS_CONFIG[entity], (page) =>
        CommonUtils.iterateKeysAnDo(
          this.PERMISSIONS_CONFIG[entity][page],
          (permissionName) => {
            this.initSinglePermission(
              {
                ...this.PERMISSIONS_CONFIG[entity][page][permissionName],
                name: permissionName,
                subject: `${entity}.${page}`,
              },
              userPermissions,
              can
            );
          }
        )
      )
    );

    return Promise.resolve();
  }

  // permission : [object] read: {strategy: 'atLeastOne', perms: ['tabs.park_stats'], subject: 'tabs.park_stats', name: 'read'}
  initSinglePermission = (
    permission = { perms: [] },
    userPermissions = [],
    can = () => {}
  ) => {
    if (permission.strategy === "atLeastOne") {
      this.initStrategyAtLeastOne(permission, userPermissions, can);
    } else if (permission.strategy === "allOf") {
      this.initStrategyAllOf(permission, userPermissions, can);
    }

    if (permission.exclude) {
      this.initExcludePermissions(permission, userPermissions, can);
    }
  };

  initExcludePermissions(
    permission = { perms: [] },
    userPermissions = [],
    can = () => {}
  ) {
    if (permission.exclude) {
      permission.exclude.forEach((excludePermission) => {
        this.initSinglePermission(
          {
            ...excludePermission,
            name: permission.name,
            subject: `${permission.subject}.${excludePermission.subject}`,
          },
          userPermissions,
          can
        );
      });
    }
  }

  // Permission strategy "atLeastOne" in the array
  initStrategyAtLeastOne(
    permission = { perms: [] },
    userPermissions = [],
    can
  ) {
    if (permission.perms.find((perm) => userPermissions.indexOf(perm) >= 0)) {
      can(permission.name, permission.subject); // ex: can('read', 'tabs.park_stats')
    }
  }

  // Permission strategy "allOf" in the array
  initStrategyAllOf(permission = { perms: [] }, userPermissions = [], can) {
    if (permission.perms.every((perm) => userPermissions.includes(perm))) {
      can(permission.name, permission.subject); // ex: can('read', 'tabs.park_stats')
    }
  }

  isUserSuperAdmin() {
    return false;
  }
}

export default new Abilities();
